import React from "react";
import styles from "./Signup.module.css";
import { ReactComponent as Logo } from "./../../graphics/images/leagueLogo.svg";
import SignupForm from "./SignupForm/SignupForm";
import FooterSteps from "./FooterSteps/FooterSteps";

function Signup(props) {
  const { user, setUser, stage, invited } = props;


  const [isFixedCss, setIsFixedCss] = React.useState(false);

  return (
    <div className={styles.signup}>
      {}
      <Logo width="55vw" />
      <SignupForm
        user={user}
        setUser={setUser}
        stage={stage}
        isFixedCss={isFixedCss}
        setIsFixedCss={setIsFixedCss}
        invited={invited}
      />
      <FooterSteps stage={stage} isFixedCss={isFixedCss} />
    </div>
  );
}

export default Signup;
